package org.hs_soft.runmynesto.data.api_datasource.product.tabs.tab_allergens

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonArray
import kotlinx.serialization.json.putJsonObject
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient
import org.hs_soft.runmynesto.domain.config.Errors
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.create_product_ingredients.CreateProductIngredientModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_allergens.CreateProductIngredientRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils

class CreateProductIngredientRepositoryImpl(
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
):CreateProductIngredientRepository
{
    override suspend fun createProductIngredient(
        productId:String,
        name: String,
        keyword: String,
        unit: String,
        number: String,
    ): CreateProductIngredientModel {

        val abortController = requestManager.createController()

        val graphQLQuery = buildJsonObject {
            put("query", """
                mutation createProductIngredient(${'$'}required: ProductIngrReqFields!,
                 ${'$'}fields: ProductIngrFields) {
                  cashAssist {
                    createProductIngredient(required:${'$'}required, fields:${'$'}fields) {
                      ${ApiUtils.Field.id}
                      ${ApiUtils.Field.amount}
                      ${ApiUtils.Field.contains}
                      ${ApiUtils.Field.ingredientId}
                      ${ApiUtils.Field.productId}
                      ${ApiUtils.Field.mod_ver}
                      ingredient {
                        ${ApiUtils.Field.id}
                        ${ApiUtils.Field.name}
                        ${ApiUtils.Field.code}
                        ${ApiUtils.Field.group}
                        ${ApiUtils.Field.units}
                        ${ApiUtils.Field.__typename}
                      }
                      ${ApiUtils.Field.__typename}
                    }
                    ${ApiUtils.Field.__typename}
                  }
                }

 
            """.trimIndent())


            putJsonObject("variables") {
                putJsonObject("fields") {
                    put("contains",true)
                    putJsonObject("ingredient") {
                        put("code",number)
                        put("keyword",keyword)
                        put("name",name)
                        put("units",unit)
                        put("group","allergens_EU")
                    }
                }
                putJsonObject("required") {
                    put("productId",productId)
                }
            }
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController,
        )

        return if (result != null) {
            Json.decodeFromString<CreateProductIngredientModel>(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }


    }

}